import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollerItem from "./ScrollerItem";
import ScrollContainer from "react-indiana-drag-scroll";

class Scroller extends Component {
  /// No longer used
  render() {
    const { categories, language, settings } = this.props;
    return (
      <div className="h-100 w-100">
        <ScrollContainer
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${categories.length + 2}, auto)`,
            gridTemplateRows: 1,
            overflow: "auto",
            height: settings.hide_bubbles_category_thumbnails ? 35 : 120,
            paddingRight: 10,
            paddingLeft: 10,
            width: "100%",
            direction: language == "english" ? "ltr" : "rtl",
          }}
          className="disable-scroll-bar w-100"
        >
          {!settings.hide_bubble_all_category && (
            <ScrollerItem
              category={{
                id: 0,
                name: "All",
                ar_name: "الكل",
                photo: this.props.logo,
              }}
              hideThumbnail={settings.hide_bubbles_category_thumbnails}
            />
          )}
          {categories
            .filter((cat) => {
              if (!cat.products?.length && !cat.has_children) return false;
              if (cat.has_children) {
                const subCats = categories.filter((subcat) =>
                  cat.sub_categories?.includes(subcat.id)
                );
                if (!subCats.length) return false;
              }
              return true;
            })
            .map((category) => (
              <ScrollerItem
                category={category}
                key={Math.random() * 999999}
                hideThumbnail={settings.hide_bubbles_category_thumbnails}
              />
            ))}
          <span style={{ width: 10 }}></span>
        </ScrollContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    categories: state.store.store.categories,
    logo: state.store.store.logo,
    settings: state.store.store.settings,
  };
};
export default connect(mapStateToProps)(Scroller);
